/**
 * Link Component.
 * It renders `anchor` Element as a Link Component, if its passed with `href`.
 * It renders `button` Element as a Link Component, if its passed without `href`.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'kepler';
import { trackLink } from '../../../lib/analytics-helper';

class Link extends Component {

  // Bind Click Event Method.
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  // Handle Click event with Tracking FPTI as a Param.
  handleClick() {
    if (this.props.trackLink && this.props.trackLink.id && this.props.trackLink.link) {
      trackLink(this.props.trackLink);
    }

    if (this.props.onClick) {
      this.props.onClick();
    }
  }

  // Render `Link` Component depends on `href` props.
  // Anchor Element for `href` props.
  // Button Element for not having `href` props.
  render() {
    if (this.props.href) {
      return (
        <Button id={this.props.id} href={this.props.href} target={this.props.target} className={this.props.classNames} type="link" onClick={this.handleClick} aria-label={this.props.label}>
          {this.props.label}
        </Button>
      );
    }

    return (
      <Button id={this.props.id} type="link" onClick={this.handleClick} className={this.props.classNames} aria-label={this.props.label}>
        {this.props.label}
      </Button>
    );
  }
}

// Link Props Types.
Link.propTypes = {
  id: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  label: PropTypes.string,
  classNames: PropTypes.string,
  trackLink: PropTypes.shape({
    id: PropTypes.string,
    link: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

// Link default values.
Link.defaultProps = {
  id: '',
  href: '',
  target: null,
  label: '',
  classNames: '',
  trackLink: {},
  onClick: () => true,
};

export default Link;



// WEBPACK FOOTER //
// ./contactUs/components/common/Link.js